<template>
  <div class="wh100">
    <el-row>
      <el-col :span="8">单位名称:</el-col>
      <el-col :span="16">{{ SewageData.SewageName }}</el-col>
    </el-row>
    <el-row>
      <el-col :span="8">详细地址:</el-col>
      <el-col :span="16">{{ SewageData.SewageAddress }}</el-col>
    </el-row>
    <el-row>
      <el-col :span="8">污水处理设施类型:</el-col>
      <el-col :span="16">{{ SewageData.SewageType }}</el-col>
    </el-row>
    <el-row>
      <el-col :span="8">经度：</el-col>
      <el-col :span="16">{{ SewageData.Lon }}</el-col>
    </el-row>
    <el-row>
      <el-col :span="8">纬度：</el-col>
      <el-col :span="16">{{ SewageData.Lat }}</el-col>
    </el-row>
  </div>
</template>

<script>
import LayoutLeftRight from "../../../../components/layout/LayoutLeftRight";
import MyChart from "../../../../components/EChart";
import MyPanel from "../../../../components/Pannel/Pannel";
export default {
  components: {
    LayoutLeftRight,
    MyChart,
    MyPanel,
  },
  props: {
    SewageData: {
      type: Object,
      default: {
        SewageName:"",
        SewageAddress:"",
        SewageType:"",
        Lon:"",
        Lat:"",
      },
    },
    
  },
  data() {
    return {
      
    };
  },
  mounted() {
    
  },
  methods: {
   
  },
  watch: {

  },
};
</script>
<style lang="less" scoped>
.el-row {
  padding: 10px 0px;
}
.left,
.right {
  border: dotted 1px violet;
  padding: 10px;
}
.selChannel {
  position: fixed;
  margin-top: 4px;
  margin-left: 33%;
}
</style>